import { ColumnType, Row } from "@asayinc/component-library";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import relativeTime from "dayjs/plugin/relativeTime";

import { IProxyEvent } from "src/store/proxyEvent/types";
import { PROXY_EVENT_LABEL } from "src/constants/labels/proxyEventLabel";

dayjs.extend(relativeTime);
dayjs.extend(utc);

export const ISSUER_PROXY_EVENTS_COLUMNS = [
  "type",
  "recordDate",
  "solicitor",
  "tabulator",
  "voteCutoff",
  "meetingDate",
];

export type ColumnDataHelpers = {
  getSort: (sortKey: string) => "asc" | "desc" | undefined;
  onOrderingChange: (data: unknown, sortKey: string) => void;
};

export type IssuerProxyEventsColumnData = {
  type: ColumnType;
  recordDate: ColumnType;
  solicitor: ColumnType;
  tabulator: ColumnType;
  voteCutoff: ColumnType;
  meetingDate: ColumnType;
};

export function getColumns() {
  return ISSUER_PROXY_EVENTS_COLUMNS;
}

export function getColumnData({
  getSort,
  onOrderingChange,
}: ColumnDataHelpers): IssuerProxyEventsColumnData {
  return {
    type: {
      sort: getSort("type"),
      sortFn: (data: unknown) => onOrderingChange(data, "type"),
      style: "text",
      title: "Type",
      tdBodyProps: {
        textProps: {
          weight: 600,
        },
      },
    },
    recordDate: {
      sort: getSort("record_date"),
      sortFn: (data: unknown) => onOrderingChange(data, "record_date"),
      style: "text",
      title: "Record Date",
    },
    solicitor: {
      style: "text",
      title: "Solicitor",
    },
    tabulator: {
      style: "text",
      title: "Tabulator",
    },
    voteCutoff: {
      sort: getSort("voteCutoff"),
      sortFn: (data: unknown) => onOrderingChange(data, "voteCutoff"),
      style: "text",
      title: "Vote Cutoff",
    },
    meetingDate: {
      sort: getSort("meetingDate"),
      sortFn: (data: unknown) => onOrderingChange(data, "meetingDate"),
      style: "text",
      title: "Meeting Date",
    },
  };
}

export function getRowData(
  events: IProxyEvent[],
  onRowClick: (event: IProxyEvent) => void
): Row[] {
  const handleRowClick = (data: unknown) => {
    const { event } = data as {
      event: IProxyEvent;
      idx: string;
    };
    onRowClick(event);
  };

  return events.map((event, idx) => {
    const {
      id,
      type,
      recordDate,
      solicitor,
      tabulator,
      voteCutoff,
      meetingDate,
    } = event;

    return {
      id,
      data: { event, idx },
      rowData: {
        type: {
          content: PROXY_EVENT_LABEL[type],
          clickHandler: handleRowClick,
        },
        recordDate: {
          content: dayjs(recordDate).format("MM/DD/YYYY"),
          clickHandler: handleRowClick,
        },
        solicitor: {
          content: solicitor.name,
          clickHandler: handleRowClick,
        },
        tabulator: {
          content: tabulator ? tabulator.name : "-",
          clickHandler: handleRowClick,
        },
        voteCutoff: {
          content: voteCutoff ? dayjs(voteCutoff).format("MM/DD/YYYY") : "-",
          clickHandler: handleRowClick,
        },
        meetingDate: {
          content: meetingDate ? dayjs(meetingDate).format("MM/DD/YYYY") : "-",
          clickHandler: handleRowClick,
        },
      },
    };
  });
}
